import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { minBp } from 'src/lib/theme';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.fonts.dinRegular};
    font-size: 14px;
    color: ${({ theme }) => theme.colors.body};
    line-height: 1.2;

    @media ${minBp('tablet')} {
      font-size: 16.66px;
    }
  }

  &:not(header) {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: ${({ theme }) => theme.fonts.dinDemi};
      font-weight: 500;
      color: ${({ theme }) => theme.colors.heading};
      line-height: 1;
    }

    h1 {
      margin: 0 0 45px;
      font-size: 80px;
    }

    h2 {
      font-size: 60px;
    }

    h3 {
      margin: 0 0 15px;
      font-size: 25px;
    }

    h4 {
      margin: 0 0 15px;
      font-size: 17px;

      @media ${minBp('tablet')} {
        font-size: 22px;
      }
    }

    p {
      margin: 0 0 5px;
      line-height: 1.375;
    }

    small {
      font-size: 75%;
    }

    strong {
      font-weight: 500;
      font-family: ${({ theme }) => theme.fonts.dinDemi};
    }

    * {
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    select,
    input {
      margin: 0;
      border: 0;

      &:focus {
        border: 0;
      }
    }

    select::-ms-expand {
      display: none;
    }

    input[type='radio'] {
      margin-top: 0;
    }
  }
`;

export default GlobalStyle;
